import React, { useState, useRef, useEffect } from "react";
import CardAddButton from "../../assets/icons/CardAddButton.svg";
import edit from "../../assets/icons/edit-3.svg";
import searchicon from "../../assets/icons/search.svg";
import Kebab from "../../assets/icons/Kebab Calculations.svg";
import print from "../../assets/icons/Print icon.svg";
import pdf from "../../assets/icons/Pdf icon.svg";
import invoice from "../../assets/icons/Invoice.svg";
import delete1 from "../../assets/icons/Group 2723.svg";
import duplicate from "../../assets/icons/Duplicate.svg";
import shoppingCart from "../../assets/icons/shopping-cart.svg";
import { useHistory, useLocation } from "react-router-dom";
import {
  FetchQuotes,
  FetchlastQuotecode,
  ProjectDropdown,
  CreateDuplicateQuotes,
  DeactivatedQuote,
  AddQuotes,
  ApproveQuotes,
  activateQuote,
} from "../../redux/actions/action";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { europeanFormatWithSymbol } from "../../utils/European-Format/NumberFormatter";
import { fetchScreenTranslations } from "../../utils/helpers/translations";
import { ROLES } from "../../utils/helpers/userRole";
import { DownloadQuotesPDF } from "../../redux/actions/proformaAction";

const AddQuotesComp = () => {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const token = window.localStorage.getItem("token");
  const roleAccess = window.localStorage.getItem("roleid");
  const projectId = window.localStorage.getItem("projectid");
  const projectName2 = window.localStorage.getItem("projectname");
  const projectCode2 = window.localStorage.getItem("projectcode");

  const [projectName, setProjectName] = useState("");
  const [projectCode, setProjectCode] = useState("");

  useEffect(() => {
    setTimeout(() => {
      const name = window.localStorage.getItem("projectname");
      const code = window.localStorage.getItem("projectcode");
      console.log("asc33", name, code);
      setProjectName(name);
      setProjectCode(code);
    }, 2000);
  }, []);

  const isViewer = process.env.REACT_APP_IS_VIEWER;

  const fetchQuotesResponse = useSelector(
    (state) => state.user.fetchQuotesResponse,
  );
  const FetchlastQuotecodeResponse = useSelector(
    (state) => state.user.FetchlastQuotecodeResponse,
  );
  const ProjectDropdownResponse = useSelector(
    (state) => state.user.fetchProjectDropdown,
  );
  const DeativatedQuoteResponse = useSelector(
    (state) => state.user.DeativatedQuoteResponse,
  );
  const CreateDuplicateQuotesResponse = useSelector(
    (state) => state.user.CreateDuplicateQuotesResponse,
  );
  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";
  const AddQuotesResponse = useSelector(
    (state) => state.user.AddQuotesResponse,
  );
  const ApproveQuotesResponse = useSelector(
    (state) => state.user.ApproveQuotesResponse,
  );
  const activateQuoteResponse = useSelector(
    (state) => state.user.activateQuoteResponse,
  );

  const [showModal, setShowModal] = useState(false);
  const [quoteList, setQuoteList] = useState([]);
  const [newQuoteCode, setNewQuoteCode] = useState("");
  const [projectDropList, setProjectDropList] = useState([]);
  const [fullProjectDropList, setFullProjectDropList] = useState([]);
  const [pageNumber, setPageNumber] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [pagesArray, setPagesArray] = useState([]);
  const [projectObject, setProjectObject] = useState({
    name: "",
    id: "",
    code: "",
  });

  const [menuActiveList, setMenuActiveList] = useState([]);

  useEffect(() => {
    // if (location?.pathname === "/updateProject") {
    if (location?.pathname.startsWith("/project/")) {
      dispatch(FetchQuotes(projectId, pageNumber, itemsPerPage));
      setProjectObject({ name: projectName, id: projectId, code: projectCode });
    }
    if (location?.pathname === "/addProject") {
      setQuoteList([]);
      setProjectObject({ name: "", id: "", code: "" });
    }
  }, [location, pageNumber, projectCode]);

  useEffect(() => {
    dispatch(FetchlastQuotecode());
    dispatch(ProjectDropdown());
  }, [location, pageNumber]);

  useEffect(() => {
    if (fetchQuotesResponse?.status === true) {
      setQuoteList(fetchQuotesResponse?.data);
      let pages = Math.ceil(fetchQuotesResponse?.totalCount / itemsPerPage);
      setTotalPages(pages);
      setTotalItems(fetchQuotesResponse?.totalCount);
      let array = [];
      for (let i = 1; i <= pages; i++) {
        array.push(i);
      }
      setPagesArray([...array]);
      if (location?.pathname === "/addProject") {
        setQuoteList([]);
        setProjectObject({ name: "", id: "", code: "" });
        setTotalItems(0);
        setTotalPages(0);
      }
    }
  }, [fetchQuotesResponse]);

  useEffect(() => {
    if (FetchlastQuotecodeResponse?.status === true) {
      setNewQuoteCode(FetchlastQuotecodeResponse?.data?.quotecode);
    }
  }, [FetchlastQuotecodeResponse]);

  useEffect(() => {
    if (ProjectDropdownResponse?.status === true) {
      setProjectDropList(ProjectDropdownResponse?.data);
      setFullProjectDropList(ProjectDropdownResponse?.data);
    }
  }, [ProjectDropdownResponse]);

  useEffect(() => {
    if (CreateDuplicateQuotesResponse?.status === true) {
      dispatch(FetchQuotes(projectId, pageNumber, itemsPerPage));
      dispatch(FetchlastQuotecode());
    }
  }, [CreateDuplicateQuotesResponse]);

  useEffect(() => {
    if (DeativatedQuoteResponse?.status === true) {
      dispatch(FetchQuotes(projectId, pageNumber, itemsPerPage));
    }
  }, [DeativatedQuoteResponse]);

  useEffect(() => {
    if (
      ApproveQuotesResponse?.status === true ||
      activateQuoteResponse?.status === true
    ) {
      dispatch(FetchQuotes(projectId, pageNumber, itemsPerPage));
    }
  }, [ApproveQuotesResponse, activateQuoteResponse]);

  useEffect(() => {
    if (AddQuotesResponse?.status === true) {
      setShowModal(false);
      if (projectId) {
        dispatch(FetchQuotes(projectId, pageNumber, itemsPerPage));
      }
      history.push(
        `/quote/${AddQuotesResponse?.data?.quoteid}`,
        // "/quote-calculation",
        `${AddQuotesResponse?.data?.quotecode}@@${AddQuotesResponse?.data?.quoteid}@@Add@@${location.pathname}`,
      );
    }
  }, [AddQuotesResponse]);

  useEffect(() => {
    fetchScreenTranslations("Add-Project").then((data) =>
      setFetchTranslationList(data),
    );
  }, []);

  useEffect(() => {
    dispatch(FetchlastQuotecode());
  }, [showModal]);

  return (
    <>
      <div className="quotes-main-container" style={{ minHeight: "30rem" }}>
        <div className="quotes-div-1 pb-4 fr">
          <section
            className={
              roleAccess === process.env.REACT_APP_IS_VIEWER
                ? "invisible"
                : "fr"
            }
            style={{ gap: "7px", alignItems: "center", cursor: "pointer" }}
            onClick={() => setShowModal(true)}
          >
            <img src={CardAddButton} className="addDocImg" alt="Add Icon" />
            <p className="addDocText">
              {/* Add Quote */}
              {t("Add Quote")}
            </p>
          </section>
          <section className="fr quotes-div-sec-2" style={{ gap: "7px" }}>
            <p>
              {pageNumber === 1 ? 1 : itemsPerPage * (pageNumber - 1) + 1}-
              {itemsPerPage * pageNumber > totalItems
                ? totalItems
                : itemsPerPage * pageNumber}
            </p>
            <p>of</p>
            <p>{totalItems}</p>
            <p
              className="aro-lr"
              onClick={() => {
                if (pageNumber === 1) return;
                setPageNumber((p) => p - 1);
              }}
            >
              {"<"}
            </p>
            <p className="quote-current-page">{pageNumber}</p>
            <p
              className="aro-lr"
              onClick={() => {
                if (pageNumber >= totalPages) return;
                setPageNumber((p) => p + 1);
              }}
            >
              {">"}
            </p>
          </section>
        </div>

        <div className="quoteListProjectSection">
          {/* <p className="quoteListHead quote-list-head-mobile">
            {packageId === process.env.REACT_APP_IS_PREMIUM ? "Link" : ""}
          </p> */}
          <p className="quoteListHead mb-2">
            {/* Quote ID */}
            {t("Quote ID")}
          </p>
          <p className="quoteListHead">
            {/* Date */}
            {t("Date")}
          </p>
          <p className="quoteListHead quote-list-head-mobile">
            {/* Total Amount */}
            {t("Total Amount ")}
          </p>
          <p className="quoteListHead quote-list-head-mobile d-none">
            Scaffolding m2
          </p>
          <p className="quoteListHead quote-list-head-mobile d-none">
            Rent&Work m2
          </p>
          <p className="quoteListHead">
            {/* Status */}
            {t("Status")}
          </p>
          <p className="quoteListHead quote-list-head-mobile d-none">
            Assignment Score
          </p>
        </div>

        {quoteList?.map((item, index) => {
          return (
            <QuoteSingle
              index={index}
              key={index}
              col1={"Quote ID"}
              col2={item.quotecode}
              col3={item.createdat}
              col4={item.total}
              status={item.status}
              quote={item}
              CreateDuplicateQuotes={CreateDuplicateQuotes}
              DeactivatedQuote={DeactivatedQuote}
              FetchTranslationList={FetchTranslationList}
              roleAccess={roleAccess}
              newQuoteCode={newQuoteCode}
              quoteId={item?.quoteid}
              setMenuActiveList={setMenuActiveList}
              menuActiveList={menuActiveList}
              client={item?.clientname}
            />
          );
        })}
        {quoteList.length === 0 && (
          <span className="noDataDisplay">
            {/* No data to display! */}
            {t("No data to display!\n")}
          </span>
        )}
      </div>

      <Modal
        showModal={showModal}
        setShowModal={setShowModal}
        newQuoteCode={newQuoteCode}
        projectDropList={projectDropList}
        setProjectDropList={setProjectDropList}
        fullProjectDropList={fullProjectDropList}
        FetchTranslationList={FetchTranslationList}
        roleAccess={roleAccess}
        projectObject={projectObject}
        setProjectObject={setProjectObject}
      />
    </>
  );
};

export default AddQuotesComp;

const Modal = ({
  showModal,
  setShowModal,
  newQuoteCode,
  projectDropList,
  setProjectDropList,
  fullProjectDropList,
  FetchTranslationList,
  roleAccess,
  projectObject,
  setProjectObject,
}) => {
  const dispatch = useDispatch();
  const [search, setSearch] = useState("");
  const [showSearchModal, setShowSearchModal] = useState(false);
  const modalRef = useRef(null);
  const t = (key) => FetchTranslationList?.[key] || "";

  useEffect(() => {
    function handleClickOutside(event) {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        setShowSearchModal(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [modalRef]);

  useEffect(() => {
    if (search) {
      let list = [...fullProjectDropList];
      list = list?.filter((project) => {
        return (
          project.projectname.toLowerCase().startsWith(search.toLowerCase()) ||
          project.projectcode.toLowerCase().startsWith(search.toLowerCase())
        );
      });
      setProjectDropList(list);
    } else {
      setProjectDropList([...fullProjectDropList]);
    }
  }, [search]);

  return (
    <>
      <div
        className="quote-modal-cont"
        style={{ transform: showModal ? "scale(1)" : "scale(0)" }}
      >
        <div className="modal-div">
          <div className="modal-div-absolute">
            <section className="quote-modal-sec1">
              {/* New Quote */}
              {t("New Quote")}
            </section>
            <section className="quote-modal-sec2">
              {/* <p>Quote ID</p> */}
              <p> {t("Quote ID")}</p>
              <article className="fr quote-number-icon">
                <p className="quote-number-bold">{newQuoteCode}</p>
                <img src={edit} style={{ cursor: "pointer" }} />
              </article>
            </section>
            <section className="quote-modal-sec3">
              {/* <p>Project</p> */}
              <p> {t("Project")}</p>
              <div className="fr quote-number-icon-2">
                {/* <p className="quote-number-bold"></p> */}
                <div className="quote-modal-select">
                  <p
                    className="choose-project"
                    onClick={() => setShowSearchModal(true)}
                  >
                    {console.log("asc34", projectObject)}
                    {/* Choose a project */}

                    {projectObject?.code && projectObject?.name
                      ? `${projectObject.code} ┃ ${projectObject.name}`
                      : t("Choose a project")}
                  </p>
                  <div
                    ref={modalRef}
                    className="choose-project-modal"
                    style={{
                      transform: showSearchModal ? "scale(1)" : "scale(0)",
                      transitionDuration: "300ms",
                    }}
                  >
                    <p className="choose-project p-3 pb-0">
                      {/* Choose a project */}
                      {t("Choose a project")}
                    </p>
                    <section
                      className="quote-modal-search mx-2"
                      style={{ width: "90%" }}
                    >
                      <img
                        src={searchicon}
                        alt="Search Icon"
                        style={{
                          flexShrink: "0",
                          width: "17px",
                          height: "17px",
                        }}
                      />
                      <input
                        className="quote-modal-input"
                        placeholder="Search..."
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                      />
                    </section>
                    <section className="quote-modal-list">
                      {projectDropList?.map((project, index) => {
                        return (
                          <p
                            className="choose-project ulterDrop"
                            key={index}
                            style={{ textTransform: "capitalize" }}
                            onClick={() => {
                              setProjectObject({
                                name: project?.projectname,
                                id: project?.projectid,
                                code: project?.projectcode,
                              });
                              setShowSearchModal(false);
                            }}
                          >
                            {project?.projectcode}&nbsp;┃&nbsp;
                            {/* {project?.projectname} */}
                            {project.projectname.length > 10
                              ? project.projectname.slice(0, 10) + "..."
                              : project.projectname}
                          </p>
                        );
                      })}
                    </section>
                  </div>
                </div>
              </div>
            </section>
            <section className="quote-modal-btns">
              <p style={{ minWidth: "60px" }}></p>
              <button
                type="button"
                className="addProCancel quote-cancel-btn"
                onClick={() => {
                  setShowModal(false);
                }}
              >
                {/* Cancel */}
                {t("Cancel ")}
              </button>
              <button
                type="button"
                className="quote-add-btn"
                onClick={() => {
                  if (!projectObject?.id) return;
                  dispatch(
                    AddQuotes(
                      projectObject?.id,
                      newQuoteCode,
                      "",
                      0,
                      "Waiting",
                    ),
                  );
                }}
              >
                {/* Add */}
                {t("Add")}
              </button>
            </section>
          </div>
        </div>
      </div>
    </>
  );
};

const QuoteSingle = ({
  index,
  col1,
  col2,
  col3,
  col4,
  status,
  quote,
  CreateDuplicateQuotes,
  DeactivatedQuote,
  FetchTranslationList,
  roleAccess,
  newQuoteCode,
  quoteId,
  setMenuActiveList,
  menuActiveList,
  client,
}) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const token = window.localStorage.getItem("token");
  const companyId = window.localStorage.getItem("companyid");
  const packageId = window.localStorage.getItem("packageId");
  const t = (key) => FetchTranslationList?.[key] || "";

  const [menuActive, setMenuActive] = useState(false);

  const deactivateFunction = () => {
    const user = window.localStorage.getItem("userid");
    if (roleAccess === ROLES.OWNER || roleAccess === ROLES.MANAGER) {
      setMenuActiveList([]);
      if (status === "Deactivated") return dispatch(activateQuote(quoteId));
      if (status === "Waiting") return dispatch(DeactivatedQuote(quoteId, 0));
      if (status === "Approved") return dispatch(DeactivatedQuote(quoteId, 0));
    }
  };

  return (
    <>
      <div
        className={`${
          status === "Deactivated"
            ? "quote-main-grid inactive-line"
            : "quote-main-grid active-line"
        }`}
      >
        {/* <p
          className={`hide-on-mobile ${
            roleAccess === process.env.REACT_APP_IS_VIEWER ? "pointerEvent" : ""
          }`}
          onClick={() => {
            history.push(
              `/quote/${quoteId}`,
              // "/quote-calculation",
              `${col2}@@${quoteId}@@Change@@/updateProject`
            );
          }}
          style={{ cursor: "pointer" }}
        >
          {col1}
        </p> */}

        <p
          className={
            roleAccess === process.env.REACT_APP_IS_VIEWER ? "pointerEvent" : ""
          }
          onClick={() => {
            history.push(
              `/quote/${quoteId}`,
              // "/quote-calculation",
              `${col2}@@${quoteId}@@Change@@/updateProject`,
            );
          }}
          style={{ cursor: "pointer" }}
        >
          {col2}
        </p>

        <p
          className={`hide-on-mobile ${
            roleAccess === process.env.REACT_APP_IS_VIEWER ? "pointerEvent" : ""
          }`}
          onClick={() => {
            history.push(
              `/quote/${quoteId}`,
              // "/quote-calculation",
              `${col2}@@${quoteId}@@Change@@/updateProject`,
            );
          }}
          style={{ cursor: "pointer" }}
        >
          {moment(col3).format("DD.MM.YYYY")}
        </p>

        <p
          className={`hide-on-mobile ${
            roleAccess === process.env.REACT_APP_IS_VIEWER ? "pointerEvent" : ""
          }`}
          onClick={() => {
            history.push(
              `/quote/${quoteId}`,
              // "/quote-calculation",
              `${col2}@@${quoteId}@@Change@@/updateProject`,
            );
          }}
          style={{ cursor: "pointer" }}
        >
          {/* {europeanFormatWithSymbol(parseInt(col4))} */}
          {europeanFormatWithSymbol(col4)}
        </p>

        <p
          className={
            roleAccess === process.env.REACT_APP_IS_VIEWE_R
              ? "pointerEvent d-none"
              : "d-none"
          }
          onClick={() => {
            history.push(
              `/quote/${quoteId}`,
              // "/quote-calculation",
              `${col2}@@${quoteId}@@Change@@/updateProject`,
            );
          }}
          style={{ cursor: "pointer" }}
        >
          {/* {col2} */}
          Scaffolding m2
        </p>

        <p
          className={
            roleAccess === process.env.REACT_APP_IS_VIEWE_R
              ? "pointerEvent d-none"
              : "d-none"
          }
          onClick={() => {
            history.push(
              `/quote/${quoteId}`,
              // "/quote-calculation",
              `${col2}@@${quoteId}@@Change@@/updateProject`,
            );
          }}
          style={{ cursor: "pointer" }}
        >
          {/* {col2} */}
          Rent&Work m2
        </p>

        <p
          className={`positionof-approval-on-mobile ${
            roleAccess === process.env.REACT_APP_IS_VIEWER ? "pointerEvent" : ""
          }`}
          style={{ textTransform: "capitalize", cursor: "pointer" }}
          onClick={() => {
            history.push(
              `/quote/${quoteId}`,
              // "/quote-calculation",
              `${col2}@@${quoteId}@@Change@@/updateProject`,
            );
          }}
        >
          {status}
        </p>

        <p
          className={
            roleAccess === process.env.REACT_APP_IS_VIEWE_R
              ? "pointerEvent d-none"
              : "d-none"
          }
          onClick={() => {
            history.push(
              `/quote/${quoteId}`,
              // "/quote-calculation",
              `${col2}@@${quoteId}@@Change@@/updateProject`,
            );
          }}
          style={{ cursor: "pointer" }}
        >
          {/* {col2} */}
          Assignment Score
        </p>

        <img
          src={Kebab}
          alt="menu icon"
          className="rt-quote-menu-icon"
          style={{
            transitionDuration: "300ms",
            opacity: status === "active" ? "1" : "0.5",
            transform: menuActiveList.includes(index) && "rotate(-90deg)",
          }}
          onClick={() => {
            const indexExists = menuActiveList.includes(index);
            if (indexExists) {
              setMenuActiveList(
                menuActiveList.filter((item) => item !== index),
              );
            } else {
              setMenuActiveList([index]);
            }
          }}
        />
        <section
          className="quote-menu quote-menu-2"
          style={{
            transform: menuActiveList.includes(index) ? "scale(1)" : "scale(0)",
            transitionDuration: "300ms",
          }}
        >
          <div className="menu-icon-cont">
            <img
              src={Kebab}
              alt="menu icon"
              className="quote-menu-icon inside-menu"
              style={{
                transform: "rotate(-90deg)",
              }}
              onClick={() => {
                setMenuActiveList([]);
              }}
            />
          </div>

          <div className="quote-menu-list fc">
            {ROLES.USER !== roleAccess &&
              ROLES.VIEWER !== roleAccess &&
              status !== "Approved" &&
              status !== "Deactivated" && (
                <section
                  className="fr menu-single-item"
                  style={{
                    gap: "10px",
                    opacity: status === "Deactivated" ? "0.6" : "1",
                    pointerEvents: status === "Deactivated" ? "none" : "auto",
                  }}
                  onClick={() => {
                    dispatch(ApproveQuotes(quoteId, token));

                    setMenuActiveList([]);
                  }}
                >
                  <img src={invoice} alt="Menu Icons" />
                  <p>
                    {/* Approve */}
                    {t("Approve")}
                  </p>
                </section>
              )}

            {ROLES.USER !== roleAccess &&
              ROLES.VIEWER !== roleAccess &&
              status === "Approved" && (
                <section
                  className="fr menu-single-item"
                  style={{
                    gap: "10px",
                    opacity: status === "Deactivated" ? "0.6" : "1",
                    pointerEvents: status === "Deactivated" ? "none" : "auto",
                  }}
                  onClick={() => {
                    history.push({
                      pathname: "/NewInvoice",
                      state: {
                        from: "Quote_Screen",
                        historyQuoteid: quote.quoteid,
                        historyQuoteCode: quote.quotecode,
                        historyProjectid: quote.projectid,
                        historyProjectName: quote.projectname,
                        historyClientName: quote.clientname.clientname,
                        historyClientid: quote.clientname.clientid,
                      },
                    });
                  }}
                >
                  <img src={invoice} alt="Menu Icons" />
                  <p>
                    {/* Make Invoice */}
                    {t("Make Invoice")}
                  </p>
                </section>
              )}

            {ROLES.USER !== roleAccess && ROLES.VIEWER !== roleAccess && (
              <section
                className="fr menu-single-item"
                style={{
                  gap: "10px",
                  opacity: status === "Deactivated" ? "0.6" : "1",
                  pointerEvents: status === "Deactivated" ? "none" : "auto",
                }}
                onClick={() => {
                  dispatch(CreateDuplicateQuotes(quote?.quoteid, newQuoteCode));
                  setMenuActiveList([]);
                }}
              >
                <img src={duplicate} alt="Menu Icons" />
                {/* <p>Duplicate</p> */}
                <p> {t("Duplicate")}</p>
              </section>
            )}

            {ROLES.VIEWER !== roleAccess && status === "Approved" && (
              <section
                className="fr menu-single-item"
                style={{
                  gap: "10px",
                  opacity: status === "Deactivated" ? "0.6" : "1",
                }}
                onClick={() => {
                  history.push({
                    pathname: `/quote/${quote?.quotecode}/purshase-order`,
                    state: {
                      projectname: quote?.projectname,
                      suppliername: client.clientname,
                      supplierid: client.clientid,
                      quoteId: quote?.quoteid,
                      quoteCode: quote?.quotecode,
                    },
                  });
                }}
              >
                <img src={shoppingCart} alt="Menu Icons" />
                <p>
                  {/* Purchase Order */}
                  {t("Purchase Order")}
                </p>
              </section>
            )}

            <section
              className="fr menu-single-item"
              style={{
                gap: "10px",
                opacity: status === "Deactivated" ? "0.6" : "1",
                pointerEvents: status === "Deactivated" ? "none" : "auto",
              }}
              onClick={() => {
                // dispatch(DownloadQuotesPDF(quote?.quoteid))
                DownloadQuotesPDF(quote?.quoteid).then(
                  (result) => {
                    console.log(result);
                  },
                  (error) => {
                    console.error(error);
                  },
                );
              }}
            >
              <img src={pdf} alt="Menu Icons" />
              <p>
                {/* Download */}
                {t("Download")}
              </p>
            </section>

            <section
              className="fr menu-single-item"
              style={{
                gap: "10px",
                opacity: status === "Deactivated" ? "0.6" : "1",
                pointerEvents: status === "Deactivated" ? "none" : "auto",
              }}
              onClick={() => {
                history.push(`/quote/${quote?.quoteid}/pdf`);
              }}
            >
              <img src={print} alt="Menu Icons" />
              {/* <p>Print</p> */}
              <p> {t("Print")}</p>
            </section>

            {(ROLES.MANAGER === roleAccess || ROLES.OWNER === roleAccess) &&
              (status === "Approved" || status === "Deactivated") && (
                <section
                  className="fr menu-single-item"
                  style={{
                    gap: "10px",
                  }}
                  onClick={() => {
                    deactivateFunction();
                    setMenuActiveList([]);
                  }}
                >
                  <img src={delete1} alt="Menu Icons" />
                  <p>{status !== "Approved" ? "Activate" : "Deactivate"}</p>
                </section>
              )}
          </div>
        </section>
      </div>
    </>
  );
};
